import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { Exchange } from './types';

type GetExchangesResponse = {
  value: Exchange[];
};

type QueryType = {
  armadores: string[];
  fechaDesde: Date | null;
  fechaHasta: Date | null;
  incluirCargas: boolean;
  codPlaya: string;
};

export const getExchanges = async (query: QueryType): Promise<Exchange[]> => {
  try {
    const res = await apiClient.post<GetExchangesResponse>(
      Endpoints.ParteDeIntercambios,
      {
        ...query,
        armadores: [query.armadores],
      }
    );

    return res.data.value || [];
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
